import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./contactlist.module.css";
import { ArrowLeft, Home, X } from "react-feather";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import Loader from "../../../../../components/Loader";
import { TableLoaderSmall } from "../../../../../components/LoaderC";
import Footer from "../../../../../components/Footer";
import ContactFilter from "./components/ContactFilter";
import AddContact from "./components/AddContact";
import ContactCard from "./components/ContactCard";
import { Link } from "react-router-dom";

const ContactList = ({ history, match }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { id } = match.params;
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [groupDetails, setGroupDetails] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [filterData, setFilterData] = useState({ searchKey: "", type: "" });
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(8);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectecId, setSelectecId] = useState(0);

    useEffect(() => {
        const getGroupDetails = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/groups/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setGroupDetails(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }

        if (id) {
            getGroupDetails();
        }

    }, [getAccessTokenSilently, id]);

    useEffect(() => {
        if (groupDetails?.contacts.length > 0) {
            let filteredDataTemp = groupDetails?.contacts;

            if (filterData.searchKey !== "") {
                let inputVal = filterData.searchKey;
                inputVal = inputVal.toLowerCase();
                filteredDataTemp = filteredDataTemp.filter((item) => {
                    return (item.first_name.toLowerCase().includes(inputVal) || item.last_name.toLowerCase().includes(inputVal) || item.name.toLowerCase().includes(inputVal) || item.email.toLowerCase().includes(inputVal) || item.phone.toLowerCase().includes(inputVal));
                });
            }

            setFilteredData(filteredDataTemp);
        }
    }, [groupDetails, filterData]);

    const confirmDelete = async () => {
        setDeleteModalOpen(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_USER_API_URL + 'v1/campaign/groups/' + groupDetails?.id + '/contacts/' + selectecId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            setLoading(false);

            setGroupDetails(prev => {
                let contacts = prev.contacts.filter(i => i?.id !== selectecId);
                return { ...prev, contacts: contacts };
            });
            setSelectecId(0);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<>
        {loading && <Loader />}
        <Helmet title={groupDetails?.title} />

        <div className={`${styles.pageTitleWrap}`}>
            <div className={`${styles.HeadTTRow}`}>
                <Link to={`/communication/campaign-groups`} className={`${styles.BackArrow}`}><ArrowLeft /></Link>
                <Typography display="inline" className={`${styles.pageTitle} ${styles.Big}`}>{groupDetails?.title}</Typography>
            </div>

            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Email Campaigns</li>
                    <li className={`${styles.breadcrumbItem}`}><Link to={"/communication/campaign-groups"}>Manage Group</Link></li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>{groupDetails?.title}</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

                    {!contentLoading && <div className="control-pane">
                        <div className={`${styles.Row}`}>

                            <ContactFilter setFilterData={setFilterData.bind(this)} setAddModalOpen={setAddModalOpen.bind(this)} />

                            <div className={`${styles.NotesRow}`}>

                                {filteredData.map((item, index) => {
                                    return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<ContactCard item={item} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setSelectecId={setSelectecId.bind(this)} groupDetails={groupDetails} />) : null;
                                })}

                                {filteredData.length > 0 && (<div className="Pagination TablePaginationNew List">
                                    <TablePagination
                                        count={filteredData.length}
                                        color="primary"
                                        page={page}
                                        rowsPerPage={perPage}
                                        onPageChange={(e, v) => setPage(v)}
                                        rowsPerPageOptions={[
                                            { label: "4", value: 4 },
                                            { label: "8", value: 8 },
                                            { label: "16", value: 16 },
                                            { label: "All", value: -1 },
                                        ]}
                                        onRowsPerPageChange={(e) => {
                                            setPage(0);
                                            setPerPage(e.target.value);
                                        }}
                                        labelRowsPerPage={"Devices per Page:"}
                                    />
                                </div>)}

                                {filteredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                    <div className={`${styles.NoDataIMG}`}>
                                        <img src="/static/img/no-prospect.png" alt="No Data" />
                                    </div>
                                    <p className={`${styles.NoDataText}`}>Let's get started!</p>
                                    <p className={`${styles.NoDataTextSub}`}>You don't have any contact saved.</p>
                                </div>)}

                            </div>

                        </div>
                    </div>}
                </div>
            </div>
        </div>

        <Dialog
            open={addModalOpen}
            onClose={(e) => { setAddModalOpen(false) }}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => { setAddModalOpen(false) }}><ArrowLeft /></button>
                Add Contacts
                <button onClick={(e) => { setAddModalOpen(false) }}><X /></button>
            </DialogTitle>
            <DialogContent>
                <AddContact groupDetails={groupDetails} setAddModalOpen={setAddModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setGroupDetails={setGroupDetails.bind(this)} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Would you like to delete this contact?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The contact will be removed immediately.You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </>);
}

export default withAuthenticationRequired(ContactList, {
    onRedirecting: () => <Loader />,
});